import logo from "./logo.png";

const obj = {
  logo,
};

export default obj;
